<template>
  <div class="knowledge-directory" @click="handleClickOutside">
    <BaseEmpty v-if="!treeDirs || treeDirs.length === 0" type="empty-item" msg="暂无目录" />
    <div v-else class="directory-tree" @click.stop>
      <directory-node
        v-for="dir in treeDirs"
        :key="dir.id"
        :dir="dir"
        :selected-dir="selectedDir"
        :level="0"
        :is-root="true"
        :all-dirs-flat="allDirsFlat"
        @on-select="handleSelect"
        @on-drop-in="$emit('on-drop-in', $event)"
        @on-drop-file="$emit('on-drop-file', $event)"
        @on-config="handleConfig"
        @on-context-action="$emit('on-context-action', $event)"
      />
    </div>
  </div>
</template>

<script>
import BaseEmpty from '@/components/base/Empty';
import UTIL from '@/utils';
import DirectoryNode from './directory-node';
export default {
  components: {BaseEmpty, DirectoryNode},
  props: {
    dirs: {
      type: Array,
      default: () => [],
    },
    selectedDir: {
      type: Object,
      default: null,
    },
  },
  computed: {
    treeDirs() {
      if (!this.dirs || this.dirs.length === 0) return [];
      return UTIL.makeTree(this.dirs, {
        KEY: 'id',
        PARENT_KEY: 'parent_id',
        LIST_KEY: 'subs',
      });
    },
    allDirsFlat() {
      return this.dirs || [];
    },
  },
  methods: {
    handleSelect(dir) {
      this.$emit('on-select', dir);
    },
    handleConfig(dir) {
      this.$emit('on-config', dir);
    },
    handleClickOutside(e) {
      // 点击空白处取消选择
      if (e.target === this.$el || e.target.classList.contains('knowledge-directory')) {
        this.$emit('on-select', null);
      }
    },
  },
};
</script>

<style lang="less" scoped>

.knowledge-directory {
  height: 100%;
  overflow: auto;
  background: #fff;
}

.directory-tree {
  padding: 4px 8px;
  .directory-item {
    padding: 2px 6px;
    margin: 0;
    min-height: 24px;
    line-height: 22px;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    user-select: none;

    &:hover {
      background: var(--border);
    }

    &.selected {
      background: var(--primary);
      color: #fff;

      .link-badge {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    .directory-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .link-badge {
      font-size: 10px;
      padding: 2px 6px;
      background: var(--subtext3);
      color: #fff;
      border-radius: 2px;
      margin-left: 5px;
    }
  }
}

.ugo-draggable {
  opacity: 0.5;
}

.ugo-droppable {
  background: var(--primary-light) !important;
  border: 2px dashed var(--primary) !important;
}
</style>
